import styled from 'styled-components/native';
import { Dimensions } from 'react-native';

const windowWidth = Dimensions.get('window').width;

export const VerticalScroll = styled.ScrollView.attrs({
  showsVerticalScrollIndicator: true,
  contentContainerStyle: {
    // `flexGrow: 1`, não `flex: 2`: com `flex` o container fica preso à altura
    // do ScrollView e não cresce com o conteúdo — a lista de comentários do
    // mobile ficava cortada e era remedida a cada atualização.
    flexGrow: 1,
    // 1rem, igual ao VerticalScroll da ClickCard e à capa acima.
    paddingHorizontal: "1rem"
  },
})`
`;

export const VerticalScrollDesktop = styled.ScrollView.attrs({
  showsVerticalScrollIndicator: true,
  contentContainerStyle: {
    alignSelf: "center",
    width: "100%",
    height: ((windowWidth * 0.7) - 32) / 1.78,
    paddingHorizontal: "1rem",
  },
})`  
`;

export const Image = styled.ImageBackground`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
`;

export const ImageBlocked = styled.View`
  /* Sem as aspas: dentro do template do styled-components elas viravam parte do
     valor, o CSS era descartado e o véu escuro sobre a capa da aula ao vivo
     simplesmente não aparecia — o texto ficava por cima da imagem crua. */
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  justify-content: center;
`;